/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var ToggleOnIcon = createIcon({
  name: 'ToggleOnIcon',
  height: 512,
  width: 576,
  svgPath: 'M576 256c0 106.039-85.961 192-192 192H192C85.961 448 0 362.039 0 256S85.961 64 192 64h192c106.039 0 192 85.961 192 192zM384 128c-70.741 0-128 57.249-128 128 0 70.741 57.249 128 128 128 70.741 0 128-57.249 128-128 0-70.741-57.249-128-128-128',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default ToggleOnIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/toggle-on-icon.js
// module id = 1026
// module chunks = 0